module.exports = __webpack_public_path__ + "img/download.7dc3d970.svg";